import React from 'react';
import PropTypes from 'prop-types';
import {observer} from "mobx-react";
import {MovableCompProps, UILOCATION} from "core/grid/component/gridComp";
import {GridDocument} from "core/document/gridDocument";
import DocumentComp from "core/document/component/documentComp";
import {ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {DomainAncestor} from "core/common/domain/DomainAncestor";
import {classNames} from "core/common/utils/domUtils";
import styled from "styled-components";
import documentService from "core/document/documentService";
import {CONTRACTSTATUS, CONTRACTTYPE, Document} from "core/document/documentDomain";
import uiService from "core/common/service/uiService";
import {MdDivider} from "core/components/blockComp/blockComp";
import {addSeparator} from "core/common/utils/arrayUtils";
import mdEntityService from "core/metamodel/mdEntityService";
import {addTenantToQuery} from "core/common/utils/utils";
import {ZzIconButtonRoute} from "core/components/buttons/icons";
import Add from "material-ui/svg-icons/content/add";
import {MODULE, PERMISSION, SECURABLE_TYPE} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import {grey400} from "material-ui/styles/colors";

const SectionHeaderDiv = styled.div`
    font-size: 15px;
    color: ${grey400}
`;

const MainDiv = styled.div`
  padding-left: 20px;
  display: flex;
  flex-direction: row;
`;

const ContractHeaderDiv = styled.div`
  display: flex;
  align-items: center;
`;

const ContractsDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const DocumentsDiv = styled.div`
  min-width: 50%;
`;

const ContractWrapperDiv = styled.div`
  min-width: 50%;
`;



interface GridDocumentCompProps extends MovableCompProps<GridDocument> {
  uiLocation?: UILOCATION;
  className?: string;
  rootObject?: DomainAncestor;
  entities: ObservableMap<MdEntity>;
}


const contractDetailRoute = "contractDetail";

@observer
export default class GridDocumentComp extends React.Component<GridDocumentCompProps, undefined> {

  static contextTypes = {
    router: PropTypes.func.isRequired,
    muiTheme: PropTypes.object
  };

  onAddContract = () => {
    console.log('onAddContract');
  };

  saveFn = (documents: Document[]) : Promise<any> => {
    let {rootObject, grid} = this.props;

    if (rootObject.$new) {
      return Promise.resolve(null);
    } else {
      return Promise.all(documents.filter(doc => doc.$new).map(doc => documentService.saveDocument(doc, grid.params)))
        .then(x => {
          return grid.search(rootObject);
        })
    }
  };

  deleteFn = (document: Document) : Promise<any> => {
    let {rootObject, grid} = this.props;

    if (rootObject.$new || document.$new) {
      return Promise.resolve(null);
    } else {
      uiService.showToolbarActionFlag();
      return documentService.deleteDocument(document.documentUuid, grid.params)
        .then(x => {
          uiService.hideToolbarActionFlag();
          return grid.search(rootObject);
        });
    }
  };


  onClickContract = (contract, event) => {
    console.log(event);
    event.preventDefault();
    this.context.router.transitionTo(contractDetailRoute, {id: contract.contractId});
  };


  render() {

    let {
      children,
      uiLocation,
      grid,
      entities,
      rootObject,
      className
    } = this.props;



    const gridClassNames = classNames({['md-grid--' + uiLocation]: !!uiLocation}, className);

    return (
      <MainDiv className={gridClassNames}>

        <DocumentsDiv>

        <SectionHeaderDiv>DOCUMENTS</SectionHeaderDiv>

        <DocumentComp documents={grid.documents} entities={entities} style={{flex: '1 1 auto'}}
                      enableUpload={true} documentEntity={entities.get('Document')} rootObject={rootObject} saveFn={this.saveFn} deleteFn={this.deleteFn}/>

        </DocumentsDiv>


        {(grid.showContract) ? (
          <ContractWrapperDiv>
          <ContractHeaderDiv>
            <SectionHeaderDiv>CONTRACTS</SectionHeaderDiv>
            {(rootObject && !rootObject.$new && grid.customer) ? (
              <ZzIconButtonRoute big routeName="contractDetail" params={{id: 'new'}}
                                 module={MODULE.core} permission={PERMISSION.New} securable={PAGE.contractDetail}
                  query={{contractStatus: CONTRACTSTATUS.DRAFT, contractType: CONTRACTTYPE.CUSTOMER_CONTRACT, customerValue: grid.customer.partyId, customerLabel: grid.customer.partyLabel()}}>
                <Add/>
              </ZzIconButtonRoute>
            ) : null}
          </ContractHeaderDiv>

            {(grid.contracts) ? (
              <ContractsDiv>
                {
                  addSeparator( grid.contracts.map((contract, index) => {

                    let contractEntity = mdEntityService.getEntity("Contract");
                    let ClosedContent: any = mdEntityService.getClosedContent("ContractForm");
                    let form = contract.getForm("ContractForm");
                    let fields = form.setupFields(contract, contract, contractEntity, entities, null);

                    return (
                      <a className="no-link" key={index}
                         href={this.context.router.makeHref(contractDetailRoute, {id: contract.contractId}, addTenantToQuery())}
                         onClick={this.onClickContract.bind(this, contract)}>

                        {React.createElement(
                          ClosedContent,
                          {
                            dataObject: contract,
                            rootObject: contract,
                            entities,
                            entity: contractEntity,
                            fields,
                            disabled: true,
                            standAlone: true
                          },
                          null
                        )}

                      </a>
                    )
                  }), <MdDivider marginRight={50} marginTop={10}/>)
                }
              </ContractsDiv>
            ) : null}

          </ContractWrapperDiv>
        ) : null}




      </MainDiv>
    );
  }

}



// WEBPACK FOOTER //
// ./src/core/document/component/gridDocumentComp.tsx